import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CodAttachment } from '../../../cod/models/cod-create.model';
import { ButtonModule, FileDropModule } from '@sag-ui';
import { Store } from '@ngxs/store';
import { DownloadAttachment } from '../../../cod/state/cod-review.action';
import { isAllowedFileType, MAX_FILE_SIZE_BYTES } from '@cod-monorepo/interfaces';

@Component({
    selector: 'app-attachments-input',
    templateUrl: './attachments-input.component.html',
    imports: [CommonModule, FileDropModule, ButtonModule],
    standalone: true
})
export class AttachmentsInputComponent {
    /* eslint-disable @typescript-eslint/no-explicit-any */
    @Input({ required: true }) form: FormGroup<any>;
    @Input({ required: true }) controlName: string;
    @Input() required = false;
    @Input() label = 'Attach Related Documents';

    constructor(private store: Store) {}

    public get attachments(): CodAttachment[] {
        if (!this.form || !this.form.get(this.controlName)) {
            return [];
        }

        return this.form.get(this.controlName)?.value || [];
    }

    public handleFileDrop(files: FileList | null): void {
        if (!files) {
            return;
        }

        const attachments = this.attachments;
        const validFiles = Array.from(files).filter(file => this.isAllowedFile(file));
        this.form.get(this.controlName)?.setValue([
            ...attachments,
            ...validFiles.map(file => ({
                name: file.name,
                file
            }))
        ]);
    }

    private isAllowedFile(file: File): boolean {
        return file.size <= MAX_FILE_SIZE_BYTES && isAllowedFileType(file.name, file.type || undefined);
    }

    public handleRemoveAttachment(index: number): void {
        const attachments = this.attachments;
        attachments.splice(index, 1);
        this.form.get(this.controlName)?.setValue(attachments);
    }

    public get disabled(): boolean {
        return this.form.get(this.controlName)?.disabled || false;
    }

    public downloadAttachment(key: string): void {
        const attachment = this.attachments.find(att => att.name === key);
        if (attachment?.file) {
            const url = URL.createObjectURL(attachment.file);
            const a = document.createElement('a');
            a.href = url;
            a.download = attachment.name;
            a.click();
            URL.revokeObjectURL(url);
        } else {
            this.store.dispatch(new DownloadAttachment(encodeURIComponent(`${this.controlName}/${key}`)));
        }
    }
}
